export default __webpack_public_path__ + "static/4-04021e1c0bac73df88dfba60416f52c5.png";